import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import useTimeout from '../../hooks/useTimeout';

interface IProps {
  children?: any;
  close?: () => void;
  isError?: boolean;
}

const Toast: FunctionComponent<PropsWithChildren<IProps>> = ({
  children,
  close,
  isError,
}: IProps) => {
  useTimeout(close, 10000);

  return (
    <div
      className={`${isError ? 'bg-red-00 ' : 'bg-neutral-12 '}
    w-[350px] max-w-full text-sm pointer-events-auto
    relative flex animate__animated animate__faster animate__zoomIn rounded-xl text-white mt-4
    shadow-toastBoxShadow
`}
    >
      <div className="flex justify-between flex-wrap w-[75%] ">
        <div className="p-4 break-words ">{children}</div>
      </div>
      <button
        onClick={close}
        type="button"
        className={`${isError && 'text-white  '} ${!isError && 'info'} absolute
top-[6%] tracking-[0.5px] text-base px-3 py-1.5  right-0

`}
      >
        Okay
      </button>
    </div>
  );
};

Toast.defaultProps = {
  children: <></>,
  close: () => ({}),
  isError: false,
};

export default Toast;
